export class FormatNumbers {
    constructor() {}

    static currency(val, decimals) {
        const options = {
            style: "currency",
            currency: "BRL",
            minimumFractionDigits: decimals > -1 ? decimals : 2,
            maximumFractionDigits: decimals > -1 ? decimals : 3
        };
        const formatNumber = new Intl.NumberFormat("pt-BR", options);
        return formatNumber.format(val);
    }

    static decimals(number, places = 0) {
        const str = Number(number).toFixed(places);
        const dots = str.split(".");
        if (dots.length > 2) {
            const lastDot = str.lastIndexOf(".");
            return (
                str.slice(0, lastDot).replace(".", "") +
                "," +
                str.slice(lastDot + 1)
            );
        }
        const lastDot = str.lastIndexOf(".");
        return lastDot >= 0
            ? str.slice(0, lastDot) + "," + str.slice(lastDot + 1)
            : str;
    }

    static byUnit(unit, value, decimals, negativeParentheses) {
        switch (unit) {
            case "day":
                return this.decimals(value, 0);
            case "int":
                return this.decimals(value, 0);
            case "currency":
                return this.currency(value);
            case "number":
                return this.decimals(value, 2);
            case "percentage":
                const formatted = this.decimals(value, decimals) + "%";
                if (negativeParentheses) {
                    return this.formatNegativeNumber({
                        number: value,
                        numberFormatted: formatted
                    });
                }
                return formatted;
            default:
                return value;
        }
    }

    static formatNegativeNumber({ number, numberFormatted }) {
        if (number < 0) {
            return `(${numberFormatted.replace("-", "")})`;
        }
        return numberFormatted;
    }
}
